import { estimateOutcomeTokenSpotValueD6 } from '@morfi/market-math';
import { D6_SCALE } from '@/config/solana';

const OUTCOME_TOKEN_SCALE_D6: bigint = BigInt(D6_SCALE);

/** Converts a user-entered outcome-token quantity to exact D6 base units. */
export function parseOutcomeTokenDisplayAmountD6(displayAmount: string): bigint | null {
  const trimmed = displayAmount.trim();
  if (!/^(?:\d+(?:\.\d{0,6})?|\.\d{1,6})$/.test(trimmed)) return null;

  const [wholePart = '0', fractionalPart = ''] = trimmed.split('.');
  const wholeD6 = BigInt(wholePart.length === 0 ? '0' : wholePart) * OUTCOME_TOKEN_SCALE_D6;
  const fractionalD6 = BigInt(fractionalPart.padEnd(6, '0'));
  return wholeD6 + fractionalD6;
}

/**
 * Parses exact API integer strings and delegates indicative spot valuation to
 * the shared SDK. Invalid or out-of-range wire values remain unavailable.
 */
export function estimateOutcomeTokenSpotValueFromStringsD6(
  outcomeAmountD6: string,
  spotPriceD9: string,
): bigint | null {
  if (!/^\d+$/.test(outcomeAmountD6) || !/^\d+$/.test(spotPriceD9)) return null;

  const result = estimateOutcomeTokenSpotValueD6({
    outcomeAmountD6: BigInt(outcomeAmountD6),
    spotPriceD9: BigInt(spotPriceD9),
  });
  return result.available ? result.value : null;
}
